export let languageData = [
    {
        languageParameter: "en",
        languageName: "English",
        languageIconClassName: "us",
        subTitle:"US"
    },
    {
        languageParameter: "es",
        languageName: "Español",
        languageIconClassName: "es",
    },
];
  
